import { inject } from '@angular/core';
import { TaApiService, CenterApiService, ClusterApiService } from '@shared/services';
import { FormConfig } from '../edit-create-form.interfaces';
import { TA_SELECT_CONFIG, TA_ACTIVE_CENTER_SELECT_CONFIG, TA_ACTIVE_CLUSTER_SELECT_CONFIG } from '@shared/components/generic-select/generic-select.configs';

export const taShiftTimeFormConfig = (): FormConfig => {
  const taApiService = inject(TaApiService);
  const centerApiService = inject(CenterApiService);
  const clusterApiService = inject(ClusterApiService);

  return {
    fields: [
      {
        key: 'id', label: 'ID', type: 'text', width: 'full', hidden: true
      },
      {
        key: 'committed', label: null as any, type: 'text', width: 'full', hidden: true
      },
      {
        key: 'taId', label: 'Trợ giảng', required: true, width: '2/3',
        type: 'select', config: { ...TA_SELECT_CONFIG, service: taApiService },
      },
      {
        key: 'date', label: 'Ngày', required: true, width: '1/3',
        type: 'datepicker', placeholder: 'Chọn ngày'
      },
      {
        key: 'studySpace', label: 'Trực Study Space', required: false, width: '1/3',
        type: 'toggleSwitch', placeholder: 'Trực Study space?', labelPosition: 'default'
      },
      {
        key: 'centerId', label: 'Trung tâm', required: false, width: '1/3',
        type: 'select', config: { ...TA_ACTIVE_CENTER_SELECT_CONFIG, service: centerApiService },
        placeholder: 'Chọn trung tâm',
        disabled: (_editMode: boolean, formValue: any) => formValue?.studySpace === true,
        validators: [(control: any) => {
          const formValue = control.parent?.value;
          if (formValue?.studySpace === false && !control.value) {
            return { required: true };
          }
          return null;
        }]
      },
      {
        key: 'clusterId', label: 'Cụm', required: false, width: '1/3',
        type: 'select', config: { ...TA_ACTIVE_CLUSTER_SELECT_CONFIG, service: clusterApiService },
        placeholder: 'Chọn cụm',
        disabled: (_editMode: boolean, formValue: any) => formValue?.studySpace === false,
        validators: [(control: any) => {
          const formValue = control.parent?.value;
          if (formValue?.studySpace === true && !control.value) {
            return { required: true };
          }
          return null;
        }]
      },
      {
        key: 'from', label: 'Từ giờ', required: true, width: 'half',
        type: 'datepicker', placeholder: 'Chọn giờ bắt đầu',
        datePickerMode: 'time'
      },
      {
        key: 'to', label: 'Đến giờ', required: true, width: 'half',
        type: 'datepicker', placeholder: 'Chọn giờ kết thúc',
        datePickerMode: 'time'
      },
      {
        key: 'note', label: 'Ghi chú', required: false, width: 'full',
        type: 'textarea', rows: 2, placeholder: 'Ghi chú cho thao tác này (tuỳ chọn)',
        hidden: (_editMode, formValue) => !formValue?.committed,
      }
    ]
  };
};
